/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import MDTypography from "components/MDTypography";

const formatCurrency = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value ?? 0);

const formatNumber = (value) =>
  new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  }).format(value ?? 0);

const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime()) || date.getFullYear() >= 9999) return "-";

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
};

const getProventTypeLabel = (proventTypeId) => {
  const labels = {
    1: "Dividendo",
    2: "JCP",
    3: "Rendimento FII",
  };

  return labels[proventTypeId] ?? "Provento";
};

const CellText = ({ children, color = "text", fontWeight = "medium" }) => (
  <MDTypography variant="caption" color={color} fontWeight={fontWeight}>
    {children}
  </MDTypography>
);

export default function data(provents = []) {
  return {
    columns: [
      { Header: "Ativo", accessor: "asset", width: "18%", align: "left" },
      { Header: "Tipo", accessor: "type", width: "14%", align: "left" },
      { Header: "Data com", accessor: "exDate", align: "center" },
      { Header: "Pagamento", accessor: "paymentDate", align: "center" },
      { Header: "Valor por cota", accessor: "amountPerUnit", align: "center" },
      { Header: "Quantidade", accessor: "quantity", align: "center" },
      { Header: "Valor previsto", accessor: "totalAmount", align: "right" },
    ],

    rows: provents.map((provent) => ({
      asset: <CellText>{provent.ticker ?? provent.name}</CellText>,
      type: <CellText fontWeight="regular">{getProventTypeLabel(provent.proventTypeId)}</CellText>,
      exDate: <CellText fontWeight="regular">{formatDate(provent.exDate)}</CellText>,
      paymentDate: <CellText fontWeight="regular">{formatDate(provent.paymentDate)}</CellText>,
      amountPerUnit: <CellText fontWeight="regular">{formatCurrency(provent.amountPerUnit)}</CellText>,
      quantity: <CellText fontWeight="regular">{formatNumber(provent.quantity)}</CellText>,
      totalAmount: <CellText color="success">{formatCurrency(provent.totalAmount)}</CellText>,
    })),
  };
}
